export default __webpack_public_path__ + "static/media/CAPABILITY_MOLDING.11fc3361.png";